import SvgIcon, { SvgIconProps } from "./SvgIcon";

const VisaIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.5 6L14.5571 2.057C14.6428 2.02361 14.7358 2.00447 14.8307 2.00069C14.9255 1.99692 15.0204 2.00859 15.1096 2.03502C15.1989 2.06145 15.2808 2.10211 15.3505 2.15461C15.4202 2.20712 15.4764 2.27043 15.5157 2.34083L17 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <rect
        x="5"
        y="6"
        width="14"
        height="16"
        rx="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
      />
      <path
        d="M9 12H12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M9 16H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default VisaIcon;
